import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Input from '../ui/Input';
import TextIcon from '../ui/icons/forms/TextIcon';

const ListSizeItem = styled.li`
  display: flex;
  flex-direction: column;
  width:33%;
  margin: 0.5vw 0px;
  justify-content: start;

  @media (max-width: 768px) {
    width: 100%;
    margin: 0 0 10px;
  }
`;

const LineWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const SizeListSmartLabel = styled.label`
  text-align: center;

  @media (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 10px;
  }
`;

const ErrorWrapper = styled.p`
  color: brown;
  font-size: smaller;
  text-transform: lowercase;
  text-align: center;
`

const FiledInputGroup = ({ input, labelText, units, placeholder, meta }) => {

  const { error, touched } = meta;
  let status = null;

  function handleFocus(event) {
    const target = event.target;
    setTimeout(() => target.select(), 0);
  }

  const showError = error && touched;
  if (showError) {
    status = 'error';
  } else {
    status = null;
  }

  return (
    <ListSizeItem>
      <SizeListSmartLabel>
        {labelText}
      </SizeListSmartLabel>
      <LineWrapper>
        <Input
          {...input}
          status={status}
          placeholder={placeholder}
          type='number'
          inputClassName='size-list__input input--text-center input--prevent-padding'
          className='size-list__input-wrapper'
          style={{ width: '100%' }}
          onFocus={handleFocus}
          iconRight={
            <TextIcon text={units}/>
          }
        />
      </LineWrapper>
      {showError &&
        <ErrorWrapper>{error}</ErrorWrapper>
      }
    </ListSizeItem>
  )
};

FiledInputGroup.propTypes = {
  input: PropTypes.object.isRequired, 
  labelText: PropTypes.string, 
  units: PropTypes.string,
  placeholder: PropTypes.string,
}

export default FiledInputGroup;